var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"setUptitle"},[_c('i',{class:_vm.icon}),_vm._v(_vm._s(_vm.name)),_vm._t("default")],2),(_vm.lineType == 1)?_c('div',{staticClass:"horizontalLine"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }